<template>
  <SectionSummary>
    <SectionSummaryRow v-if="showDiscount">
      <template #description>
        <SectionSummaryText :text="sectionSummary.discount.displayName" />
      </template>
      <template #value>
        <SectionSummaryText :text="discountValueText" red />
      </template>
    </SectionSummaryRow>
    <SectionSummaryRow v-if="showTax">
      <template #description>
        <SectionSummaryText :text="sectionSummary.tax.displayName" />
      </template>
      <template #value>
        <SectionSummaryText :text="taxValueText" />
      </template>
    </SectionSummaryRow>
    <SectionSummaryRow>
      <template #description>
        <SectionSummaryText :text="sectionSummary.price.displayName" bold />
      </template>
      <template #value>
        <SectionSummaryText :text="subTotalValueText" bold />
      </template>
    </SectionSummaryRow>
  </SectionSummary>
</template>
<script lang="ts" setup>
import type { Field, PricingTable } from '@getaccept/editor-lib';
import { toRefs } from 'vue';
import { usePricingTableSectionSummary } from '@getaccept/editor-lib/src/composables/pricing-table-section-summary.composable';
import SectionSummary from '@getaccept/editor-lib/src/components/pricing-table/section-summary/SectionSummary.vue';
import SectionSummaryRow from '@getaccept/editor-lib/src/components/pricing-table/section-summary/SectionSummaryRow.vue';
import SectionSummaryText from '@getaccept/editor-lib/src/components/pricing-table/section-summary/SectionSummaryText.vue';
import { useInjectEditorViewState } from '../../composables/editor-view-state.composable';

const { productProperties } = useInjectEditorViewState();

const props = defineProps<{
  pricingTable: PricingTable;
  sectionId: string;
  fields: Field[];
}>();

const { pricingTable, sectionId, fields } = toRefs(props);

const {
  sectionSummary,
  showDiscount,
  showTax,
  discountValueText,
  taxValueText,
  subTotalValueText,
} = usePricingTableSectionSummary(pricingTable, sectionId, fields, productProperties);
</script>
